module.exports = __webpack_public_path__ + "static/img/e-learning_doc.bcee5e59.svg";